export default __webpack_public_path__ + "static/media/tirbe.cf2ba464.svg";